// @flow

import { flatten, without } from 'lodash';

// Generic side effect callback
type Then = any => void;

// The props required for creating a side effect
export type SideEffectProps<TCallback: Then> = {
  // A human-friendly name for the side effect
  name?: string,
  // When should this side-effect run? A `redux` action type, `apollo` operation name, etc...
  when: string | Array<string>,
  // Then invoke this side-effect
  then: TCallback,
};

// A side effect
//
// Currently the same as construction props.
// This indirection decouples the two.
export type SideEffect = SideEffectProps<Then>;

// Side effect factory
export const sideEffect = <TCallback: Then>(
  props: SideEffectProps<TCallback>
): SideEffect => {
  return {
    name: props.name,
    when: flatten([props.when]),
    then: props.then,
  };
};

// Collection of all registered SideEffects
export type SideEffectRegistry = {
  effects: Array<SideEffect>,

  register: (...effects: Array<SideEffect>) => void,

  unregister: (...effects: Array<SideEffect>) => void,
};

// Factory for SideEffectRegistry type
export const createSideEffectRegistry = (): SideEffectRegistry => {
  let currentEffects: Array<SideEffect> = [];

  return {
    get effects() {
      return currentEffects;
    },

    register(...effects: Array<SideEffect>) {
      currentEffects = [...currentEffects, ...effects];
    },

    unregister(...effects: Array<SideEffect>) {
      currentEffects = without(currentEffects, ...effects);
    },
  };
};
